import cn from 'classnames';
import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';
import styles from './iconCheckmark.scss';

// tslint:disable: max-line-length
export const IconCheckmark = (props: IconProps) => (
  <svg
    className={cn(styles.base, iconStyles(props))}
    viewBox="0 0 10 8"
    xmlns="http://www.w3.org/2000/svg"
    stroke="none"
    fill="none"
  >
    <path
      stroke="none"
      d="M3.17794 5.83931L0.807277 3.53781L0 4.31601L3.17794 7.40125L10 0.778207L9.19841 0L3.17794 5.83931Z"
      fill="#11AA2B"
    />
  </svg>
);
